if (!customElements.get('grid-product')) {
    class GridProduct extends HTMLElement {
        constructor() {
            super();
            this.showMoreFunction = this.getAttribute('data-show-view-more') === 'true';
            this.showMoreCount = parseInt(this.getAttribute('data-view-more-limit'), 10) || 0;

            // 缓存 DOM 元素
            this.showMoreButton = this.querySelector('.grid-product-view-more');
            this.itemsContainer = this.querySelector('.grid-product-list');
            this.items = this.itemsContainer.querySelectorAll('.grid-product_item');
            this.clicked = false;
        }

        connectedCallback() {
            if (matchMedia('(max-width: 1000px)').matches) {
                this.initShowMoreFunction();
                window.addEventListener('resize', this.handleResize.bind(this));
            } else {
                this.showAllItems();
            }
        }

        initShowMoreFunction() {
            if (this.showMoreFunction && !this.clicked) {
                this.toggleItemsVisibility();

                this.itemsContainer.setAttribute('aria-expanded', 'false');

                this.showMoreButton.addEventListener('click', this.showAllItems.bind(this));
            }
        }

        showAllItems() {
            this.items.forEach(item => item.classList.remove('hidden'));
            this.itemsContainer.setAttribute('aria-expanded', 'true');
            this.showMoreButton.classList.add('hidden');
            this.clicked = true;
        }

        toggleItemsVisibility() {
            this.items.forEach((item, index) => {
                if (index >= this.showMoreCount) {
                    item.classList.add('hidden');
                } else {
                    item.classList.remove('hidden');
                }
            });
        }

        handleResize() {
            if (matchMedia('(max-width: 1000px)').matches) {
                if (!this.clicked) {
                    this.toggleItemsVisibility();
                }
            }
        }
    }

    customElements.define('grid-product', GridProduct);
}
